module.exports = __webpack_public_path__ + "static/img/404-1.11ec77f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404-1.png
// module id = 345
// module chunks = 1